import React, { useState, useEffect } from 'react';
import './ResenasData.css';
import baseURL from '../../url';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';

export default function ResenasData() {
    const [resenas, setResenas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filtro, setFiltro] = useState('todas'); // todas | pendientes | aprobadas | rechazadas

    useEffect(() => { cargar(); }, []);

    const cargar = () => {
        setLoading(true);
        fetch(`${baseURL}/resenasGet.php`)
            .then(r => r.json())
            .then(d => setResenas(d.resenas || []))
            .catch(() => setResenas([]))
            .finally(() => setLoading(false));
    };

    const aprobar = async (r) => {
        const fd = new FormData();
        fd.append('idResena', r.idResena);
        fd.append('estado', 'aprobada');
        try {
            const res = await fetch(`${baseURL}/resenaUpdate.php`, { method: 'POST', body: fd });
            const d = await res.json();
            if (d.mensaje) { toast.success('Reseña aprobada ✅'); cargar(); }
            else toast.error(d.error || 'Error');
        } catch { toast.error('Error de conexión'); }
    };

    const rechazar = async (r) => {
        const fd = new FormData();
        fd.append('idResena', r.idResena);
        fd.append('estado', 'rechazada');
        try {
            const res = await fetch(`${baseURL}/resenaUpdate.php`, { method: 'POST', body: fd });
            const d = await res.json();
            if (d.mensaje) { toast.success('Reseña rechazada'); cargar(); }
            else toast.error(d.error || 'Error');
        } catch { toast.error('Error de conexión'); }
    };

    const eliminar = (r) => {
        Swal.fire({ title: '¿Eliminar reseña?', icon: 'warning', showCancelButton: true, confirmButtonColor: '#e53935', confirmButtonText: 'Eliminar', cancelButtonText: 'Cancelar' })
            .then(async res => {
                if (!res.isConfirmed) return;
                const fd = new FormData();
                fd.append('idResena', r.idResena);
                const resp = await fetch(`${baseURL}/resenaDelete.php`, { method: 'POST', body: fd });
                const d = await resp.json();
                if (d.mensaje) { toast.success('Eliminada'); cargar(); }
                else toast.error(d.error || 'Error');
            });
    };

    const resenasVisibles = resenas.filter(r => {
        if (filtro === 'todas') return true;
        return r.estado === filtro;
    });

    const Estrellas = ({ n }) => (
        <div className="estrellas">
            {[1,2,3,4,5].map(i => (
                <span key={i} style={{ color: i <= Number(n) ? '#f59e0b' : '#ddd', fontSize: 16 }}>★</span>
            ))}
        </div>
    );

    const badgeEstado = (estado) => {
        const map = { aprobada: ['✅', 'aprobada'], rechazada: ['⛔', 'rechazada'], pendiente: ['⏳', 'pendiente'] };
        const [icon, cls] = map[estado] || ['⏳', 'pendiente'];
        return <span className={`resena-badge ${cls}`}>{icon} {estado || 'pendiente'}</span>;
    };

    return (
        <div className="resenasData">
            <ToastContainer />
            <div className="resenasHeader">
                <div>
                    <h2>⭐ Reseñas</h2>
                    <p>Modera las reseñas de tus productos.</p>
                </div>
                <div className="resenasFiltros">
                    {['todas', 'pendiente', 'aprobada', 'rechazada'].map(f => (
                        <button key={f} className={`filtroBtn ${filtro === f ? 'active' : ''}`} onClick={() => setFiltro(f)}>
                            {f.charAt(0).toUpperCase() + f.slice(1)}
                            <span className="filtroCnt">{f === 'todas' ? resenas.length : resenas.filter(r => r.estado === f).length}</span>
                        </button>
                    ))}
                </div>
            </div>

            {loading ? <div className="resenasLoading">Cargando...</div> :
                resenasVisibles.length === 0 ? (
                    <div className="resenasVacio">
                        <span>⭐</span>
                        <p>No hay reseñas en esta categoría.</p>
                    </div>
                ) : (
                    <div className="resenasLista">
                        {resenasVisibles.map(r => (
                            <div key={r.idResena} className={`resenaCard ${r.estado}`}>
                                <div className="resenaTop">
                                    <div className="resenaLeft">
                                        <div className="resenaAvatar">{r.nombreRevisor?.[0]?.toUpperCase() || '?'}</div>
                                        <div>
                                            <div className="resenaRevisor"><strong>{r.nombreRevisor || 'Anónimo'}</strong></div>
                                            <Estrellas n={r.calificacion} />
                                            <div className="resenaFecha">{r.fecha ? new Date(r.fecha).toLocaleDateString('es') : '—'}</div>
                                        </div>
                                    </div>
                                    <div className="resenaRight">
                                        {badgeEstado(r.estado)}
                                        <div className="resenaId">ID reseña: #{r.idResena}</div>
                                    </div>
                                </div>

                                <div className="resenaProducto">
                                    📦 Producto ID: <strong>#{r.idProducto}</strong>
                                    {r.nombreProducto && <span> — {r.nombreProducto}</span>}
                                </div>

                                <div className="resenaComentario">"{r.comentario}"</div>

                                <div className="resenaAcciones">
                                    {r.estado !== 'aprobada' && (
                                        <button className="btnAprobar" onClick={() => aprobar(r)}>✅ Aprobar</button>
                                    )}
                                    {r.estado !== 'rechazada' && (
                                        <button className="btnRechazar" onClick={() => rechazar(r)}>⛔ Rechazar</button>
                                    )}
                                    <button className="btnEliminarResena" onClick={() => eliminar(r)}>🗑️ Eliminar</button>
                                </div>
                            </div>
                        ))}
                    </div>
                )
            }
        </div>
    );
}
